// extracted by mini-css-extract-plugin
export default {"container":"oT-z","title":"pT-z","link":"qT-z"};